import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List } from "immutable";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import { getPurchaseOrders, cleanPurchaseOrders } from "../../../actions/purchase-orders";

class SupplierOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            purchaseOrderFilters: ''
        };
    }
    componentDidMount() {
        this.props.getPurchaseOrders({
            filters: {
                supplier: this.props.supplierId
            },
            projection: 'order_code document_date expected_delivery_date supplier statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'supplier',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'purchase-orders'
        });
    }
    componentWillUnmount() {
        this.props.cleanPurchaseOrders();
    }

    render() {

        // PurchaseOrders Table
        let tableData = this.props.purchaseOrders;
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            order_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'order_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/pedidos/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expected_delivery_date: {
                title: "Fecha prevista de entrega",
                columnType: 'date',
                dataField: 'expected_delivery_date',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            supplier: {
                title: "Proveedor",
                columnType: 'text',
                dataField: 'supplier',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'pending':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'requested':
                            data.badgeColor = 'warning';
                            data.value = 'Solicitado';
                            break;
                        case 'partial':
                            data.badgeColor = 'warning-light';
                            data.value = 'Parcial';
                            break;
                        case 'received':
                            data.badgeColor = 'primary';
                            data.value = 'Recibido';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/pedidos/' + value)} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Filters
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.purchaseOrders.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                        <strong>Pedidos</strong>
                    </span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                </div>
                { this.props.status === 'active'
                    ? <div className="col-auto ml-auto">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.props.history.push('/compras/pedidos/nuevo', {
                                supplierId: this.props.supplierId
                            })}
                        >
                            <Icon icon="insert"/>Pedidos
                        </button>
                    </div>
                    : null
                }
            </div>
        );
        switch (this.state.purchaseOrderFilters) {
            case 'pending':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>
                                <strong>Pendientes</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/compras/pedidos/nuevo', {
                                        supplierId: this.props.supplierId
                                    })}
                                >
                                    <Icon icon="insert"/>Pedidos
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'pending' );
                break;
            case 'requested':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>
                                <strong>Solicitados</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/compras/pedidos/nuevo', {
                                        supplierId: this.props.supplierId
                                    })}
                                >
                                    <Icon icon="insert"/>Pedidos
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'requested' );
                break;
            case 'partial':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>
                                <strong>Parciales</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/compras/pedidos/nuevo', {
                                        supplierId: this.props.supplierId
                                    })}
                                >
                                    <Icon icon="insert"/>Pedidos
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'partial' );
                break;
            case 'received':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>
                                <strong>Recibidos</strong>
                            </span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/compras/pedidos/nuevo', {
                                        supplierId: this.props.supplierId
                                    })}
                                >
                                    <Icon icon="insert"/>Pedidos
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'received' );
                break;
            default :
                break;
        }

        return (
            <div className="panel-body">
                { statsZone }
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const purchaseOrdersReducer = state.purchaseOrders;

    // PurchaseOrders
    let purchaseOrders = purchaseOrdersReducer.get('payload') || List([]);

    if (!(purchaseOrders instanceof List)) {
        purchaseOrders = List([])
    }

    return {
        purchaseOrders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPurchaseOrders: (query) => dispatch(getPurchaseOrders(query)),
        cleanPurchaseOrders: () => dispatch(cleanPurchaseOrders())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierOrders);


// WEBPACK FOOTER //
// ./src/containers/purchases/suppliers/SupplierOrders.js